import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../common/CustomBtn";
import { useTranslation } from "react-i18next";
import gallery1 from "../../assets/work_completed/work-completed7.webp";
import gallery2 from "../../assets/work_completed/work-completed1.webp";
import gallery3 from "../../assets/equipments/outdoor-sport3.avif";
import gallery4 from "../../assets/work_completed/work-completed24.webp";
import gallery5 from "../../assets/work_completed/work-completed47.webp";
import Modal from "../common/CustomModal";
import YouTube from "react-youtube";

const Gallery = () => {
  const { t } = useTranslation();

  const galleryImages = [
    {
      type: "video",
      videoId: "wjWcHwQ4PLg",
      caption: t("galleryTranslate.video_caption1"),
    },
    {
      img: gallery1,
      caption: t("galleryTranslate.video_caption2"),
    },
    {
      img: gallery2,
      caption: t("galleryTranslate.video_caption3"),
    },
    {
      img: gallery3,
      caption: t("galleryTranslate.video_caption4"),
    },
    {
      img: gallery4,
      caption: t("galleryTranslate.video_caption5"),
    },
    {
      img: gallery5,
      caption: t("galleryTranslate.video_caption6"),
    },
    {
      type: "video",
      videoId: "grNfsaATRsY",
      caption: t("galleryTranslate.video_caption1"),
    },
  ];
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  return (
    <section className="w-full h-full">
      <div className="flex flex-col items-center w-full">
        <div className="grid w-full grid-cols-2 ss:grid-cols-3 md:grid-cols-4">
          <div className="w-full  max-h-[259px] h-[200px] sm:h-[259px] p-5 text-white bg-black ss:p-8">
            <h2 className="mb-5 font-bold leading-tight text-[28px] ss:text-md md:text-lg max-w-[150px] ">
              {t("galleryTranslate.our_gallery")}
            </h2>

            <div>
              <CustomButton
                variant="outlined"
                sx={{ border: "2px solid #2E7FC3" }}
                color="white"
                onClick={() => navigate("/galerija")}
              >
                {t("galleryTranslate.button_text")}
              </CustomButton>
            </div>
          </div>

          {galleryImages.map((item, idx) => (
            <div
              key={idx}
              className="relative border flex flex-col justify-end p-6 max-h-[259px] h-[200px] sm:h-[259px] w-full cursor-pointer overflow-hidden shadow-xl group aspect-[4/3]"
            >
              {item.type === "video" ? (
                <div className="absolute inset-0 w-full h-full">
                  <YouTube
                    videoId={item.videoId}
                    opts={{
                      height: "100%",
                      width: "100%",
                      playerVars: {
                        autoplay: 1,
                        mute: 1,
                        loop: 1,
                        playlist: item.videoId,
                      },
                    }}
                    className="absolute inset-0 w-full h-full"
                  />
                  <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between px-5 py-4 transition-all duration-700 ease-in-out translate-y-5 shadow-lg opacity-0 bg-white/80 backdrop-blur-md group-hover:opacity-100 group-hover:translate-y-0">
                    <span className="text-[10px] ss:text-[14px] font-medium text-[#000000bd]">
                      {item.caption}
                    </span>
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className="absolute inset-0 w-full h-full transition-all duration-300 transform bg-center bg-cover group-hover:scale-105"
                    style={{
                      backgroundImage: `url(${item.img})`,
                    }}
                  />

                  <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between px-5 py-4 transition-all duration-700 ease-in-out translate-y-5 shadow-lg opacity-0 bg-white/80 backdrop-blur-md group-hover:opacity-100 group-hover:translate-y-0">
                    <span className="text-[10px] ss:text-[14px] font-medium text-[#000000bd]">
                      {item.caption}
                    </span>
                  </div>

                  <img
                    src={item.img}
                    alt="gallery-img"
                    className="object-cover w-full h-full"
                    style={{ opacity: 0 }}
                    onClick={() => setSelectedImage(item.img!)}
                  />
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        size="max-content"
      >
        <img
          src={selectedImage!}
          className="object-contain max-h-[80vh] w-auto max-w-full"
          alt="gallery"
        />
      </Modal>
    </section>
  );
};

export default Gallery;
